import { Amenity } from '@apis/index'
import Button from '@components/button'
import Fields from '@components/fields'

import Row from '@components/row'
import Wrapper from '@components/wrapper'

import theme from '@utils/theme'
import { Form, Formik } from 'formik'
import React, { Fragment, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useIsMobile from '@hooks/useIsMobile'

const AmenityForm = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const isMobile = useIsMobile()
  const [initialValues, setInitialValues] = useState<any>({
    link: '',
    image: '',
  })

  useEffect(() => {
    if (!!state) {
      setInitialValues({
        link: state.name,
        image: state.image,
      })
    } else {
      setInitialValues({
        link: '',
        image: '',
      })
    }
  }, [state])

  const handleSubmit = async (values: typeof initialValues, { resetForm }) => {
    try {
      const payload = {
        name: values.link,
        icon:
          typeof values.image === 'string'
            ? values.image
            : {
                extension: values.image.extension,
                base64: values.image.base64,
              },
      }
      if (!!state) {
        await Amenity.update({
          state: 'amenities',
          id: state.id,
          data: JSON.stringify(payload),
        })
        navigate('/admin/amenity-setup', { state: null })
        resetForm()
      } else {
        await Amenity.create({
          state: 'amenities',
          data: JSON.stringify(payload),
        })
        resetForm()
      }
    } catch (error) {}
  }

  return (
    <Fragment>
      <Wrapper>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ resetForm }) => (
            <Form>
              <div
                style={{
                  display: 'flex',
                  flexWrap: isMobile ? 'wrap' : '',
                  gap: '20px',
                  alignItems: 'flex-start',
                }}
              >
                <div
                  style={{
                    flex: '1 1 100%',
                    maxWidth: '100%',
                    minWidth: 0,
                  }}
                >
                  <Fields.Input
                    name="link"
                    label="Amenity Name"
                    placeholder="Type here"
                  />
                </div>

                <div
                  style={{
                    flex: '1 1 100%',
                    maxWidth: '100%',
                    minWidth: 0,
                  }}
                >
                  <Fields.Upload name="image" variant="banner" />
                </div>
              </div>

              <div
                style={{
                  justifyContent: 'flex-end',
                  marginTop: '20px',
                  gap: '12px',
                  flexWrap: 'wrap',
                  display: 'flex',
                }}
              >
                <Button
                  type="button"
                  title="Reset"
                  height={45}
                  width={100}
                  styleButton={outlineButton}
                  onClick={() => resetForm()}
                />
                <Button
                  title={!state ? 'Submit' : 'Update'}
                  height={45}
                  width={100}
                  type="submit"
                />
                {!!state && (
                  <Button
                    title={'Cancel'}
                    height={45}
                    width={100}
                    type="submit"
                    styleButton="background:red"
                    onClick={() => {
                      navigate('/admin/amenity-setup', { state: null })
                    }}
                  />
                )}
              </div>
            </Form>
          )}
        </Formik>
      </Wrapper>
    </Fragment>
  )
}

export default AmenityForm

const outlineButton = `
  background: transparent;
  border: 1px solid ${theme.colors.primary};
  color: ${theme.colors.primary};
`
